import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4 col-sm-12 col-xm-12 mb-3" }
const _hoisted_5 = { class: "col-md-4 col-sm-12 col-xm-12" }
const _hoisted_6 = { class: "col-md-4 col-sm-12 col-xm-12" }
const _hoisted_7 = { class: "col-md-4 col-sm-12 col-xm-12" }
const _hoisted_8 = { class: "form-group mb-8 mb-sm-10 mb-md-15" }
const _hoisted_9 = { class: "col-md-4 col-sm-12 col-xm-12" }
const _hoisted_10 = { class: "form-group mb-8 mb-sm-10 mb-md-15" }
const _hoisted_11 = { class: "col-md-4 col-sm-12 col-xm-12" }
const _hoisted_12 = { class: "form-group mb-8 mb-sm-10 mb-md-15" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "form-group mb-8 mb-sm-10 mb-md-15" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = {
  key: 0,
  class: "col"
}
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "col-md-12 mb-3" }
const _hoisted_21 = { class: "form-group mb-8 mb-sm-10 mb-md-15" }
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = { class: "col-md-12 mb-md-25" }
const _hoisted_24 = {
  class: "tab-pane fade show active p-10",
  id: "home-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "border border-primary mb-10" }
const _hoisted_27 = {
  class: "row d-flex align-items-center justify-content-between fw-bold py-2",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_28 = { class: "col-md-5" }
const _hoisted_29 = { class: "d-flex float-end" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 0,
  class: "row d-flex align-items-center justify-content-between mt-10"
}
const _hoisted_32 = { class: "col-md-3 mb-2" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_35 = { class: "col mb-2" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = ["onUpdate:modelValue"]
const _hoisted_38 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_39 = { class: "col mb-2" }
const _hoisted_40 = { class: "form-group" }
const _hoisted_41 = ["onUpdate:modelValue"]
const _hoisted_42 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_43 = { class: "col-md-2 mb-2" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_47 = { class: "col-md-3 mb-2" }
const _hoisted_48 = { class: "form-group" }
const _hoisted_49 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_50 = { class: "col mb-2" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "col-md-12 mt-3" }
const _hoisted_53 = { class: "d-flex align-items-center" }
const _hoisted_54 = {
  class: "btn btn-success me-3",
  type: "submit"
}
const _hoisted_55 = {
  class: "btn btn-success",
  type: "button",
  disabled: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "contratForm",
        onSubmit: _ctx.addContrat,
        "validation-schema": _ctx.contratSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[16] || (_cache[16] = _createElementVNode("label", {
                for: "date_initialisation",
                class: "form-label"
              }, [
                _createTextVNode("Date Contrat"),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, {
                name: "date_initialisation",
                class: "form-control",
                type: "Date"
              }),
              _createVNode(_component_ErrorMessage, {
                name: "date_initialisation",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[17] || (_cache[17] = _createElementVNode("label", {
                for: "dateMiseEnService",
                class: "form-label"
              }, [
                _createTextVNode("Date Mise En Service"),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, {
                name: "dateMiseEnService",
                class: "form-control",
                type: "Date"
              }),
              _createVNode(_component_ErrorMessage, {
                name: "dateMiseEnService",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                _createTextVNode(" Place "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, { name: "place" }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_component_Multiselect, _mergeProps(field, {
                    placeholder: "Rechercher une place",
                    modelValue: _ctx.placeId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.placeId) = $event)),
                    "filter-results": false,
                    "min-chars": 3,
                    "resolve-on-load": false,
                    delay: 0,
                    searchable: true,
                    "options-limit": 300,
                    onSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.placeSelectionner($event))),
                    options: async (query) => {
                  return await _ctx.fetchPlaces(query)
                },
                    noResultText: "Aucun enregistrement trouvé",
                    noOptionsText: "Tapez au moins trois caractères"
                  }), null, 16, ["modelValue", "options"])
                ]),
                _: 1
              }),
              _createVNode(_component_ErrorMessage, {
                name: "place",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Marchand "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "usager" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      placeholder: "Rechercher un marchand",
                      "filter-results": false,
                      "min-chars": 3,
                      "resolve-on-load": false,
                      delay: 0,
                      searchable: true,
                      "options-limit": 300,
                      options: async (query) => {
                    return await _ctx.fetchUsagers(query)
                  },
                      noResultText: "Aucun enregistrement trouvé",
                      noOptionsText: "Tapez au moins trois caractères"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "usager",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[20] || (_cache[20] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Groupe de Taxe du loyer "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "groupeTaxe",
                  modelValue: _ctx.groupeDeTaxeSelected,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.groupeDeTaxeSelected) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps(field, {
                      placeholder: "Rechercher un groupe de taxe",
                      contratholder: "Rechercher un groupe",
                      "filter-results": false,
                      "min-chars": 3,
                      "resolve-on-load": false,
                      delay: 0,
                      searchable: true,
                      "options-limit": 300,
                      options: _ctx.groupeTaxeOption,
                      noResultText: "Aucun enregistrement trouvé",
                      noOptionsText: "Tapez au moins trois caractères"
                    }), null, 16, ["options"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "groupeTaxe",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-5" }, [
                  _createTextVNode(" Activite "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "activite" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      placeholder: "Rechercher une activité",
                      "filter-results": false,
                      "min-chars": 3,
                      "resolve-on-load": false,
                      delay: 0,
                      searchable: true,
                      "options-limit": 300,
                      options: async (query) => {
                    return await _ctx.fetchActivites(query)
                  },
                      noResultText: "Aucun enregistrement trouvé",
                      noOptionsText: "Tapez au moins trois caractères"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "activite",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[22] || (_cache[22] = _createElementVNode("label", {
                for: "loyer",
                class: "form-label"
              }, [
                _createTextVNode("Loyer"),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, {
                name: "loyer",
                class: "form-control",
                type: "number",
                modelValue: _ctx.loyerBasePlace,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loyerBasePlace) = $event)),
                onKeydown: _cache[4] || (_cache[4] = ($event: any) => (['-', 'e', 'E', '+'].includes($event.key) && $event.preventDefault()))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "loyer",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "d-block text-black mb-10" }, [
                  _createTextVNode(" AIB "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "aib",
                  modelValue: _ctx.aib,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.aib) = $event)),
                  type: "text"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      searchable: true,
                      options: [
                  { value: 1, label: '1 %' },
                  { value: 5, label: '5 %' },
                ],
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { contratholder: "Sélectionner un élément" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "aib",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[24] || (_cache[24] = _createElementVNode("label", {
                for: "montantAib",
                class: "form-label"
              }, [
                _createTextVNode("Montant AIB"),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, {
                name: "montantAib",
                class: "form-control",
                type: "number",
                modelValue: _ctx.montantAib,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.montantAib) = $event)),
                onKeydown: _cache[7] || (_cache[7] = ($event: any) => (['-', 'e', 'E', '+'].includes($event.key) && $event.preventDefault()))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "montantAib",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[25] || (_cache[25] = _createElementVNode("label", {
                for: "caution",
                class: "form-label"
              }, [
                _createTextVNode("Caution"),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, {
                name: "caution",
                class: "form-control",
                type: "number",
                modelValue: _ctx.caution,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.caution) = $event)),
                onKeydown: _cache[9] || (_cache[9] = ($event: any) => (($event.key === 'e' || $event.key === 'E' || $event.key === '+' || $event.key === '-') && $event.preventDefault()))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "caution",
                class: "text-danger"
              })
            ]),
            (_ctx.estTPS)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _cache[26] || (_cache[26] = _createElementVNode("label", {
                    for: "montantTPS",
                    class: "form-label"
                  }, [
                    _createTextVNode("Montant TPS"),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createVNode(_component_Field, {
                    name: "montantTPS",
                    class: "form-control",
                    type: "number",
                    modelValue: _ctx.montantTPS,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.montantTPS) = $event)),
                    onKeydown: _cache[11] || (_cache[11] = ($event: any) => (($event.key === 'e' || $event.key === 'E' || $event.key === '+' || $event.key === '-') && $event.preventDefault()))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "montantTPS",
                    class: "text-danger"
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              _cache[27] || (_cache[27] = _createElementVNode("label", {
                for: "montantContrat",
                class: "form-label"
              }, [
                _createTextVNode("Montant Contrat"),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _createVNode(_component_Field, {
                name: "montantContrat",
                class: "form-control",
                type: "number",
                modelValue: _ctx.montantContrat,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.montantContrat) = $event)),
                onKeydown: _cache[13] || (_cache[13] = ($event: any) => (($event.key === 'e' || $event.key === 'E' || $event.key === '+' || $event.key === '-') && $event.preventDefault()))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ErrorMessage, {
                name: "montantContrat",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[28] || (_cache[28] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-5" }, " Observation ", -1)),
                _createVNode(_component_Field, {
                  name: "observation",
                  cols: "20",
                  rows: "3",
                  as: "textarea",
                  placeholder: "Observation",
                  class: "form-control shadow-none rounded-0 text-black"
                }, {
                  default: _withCtx(({ field }) => [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                      class: "form-control shadow-none rounded-0 text-black"
                    }, null, 8, _hoisted_22), [
                      [_vModelText, field.value]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "observation",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _cache[30] || (_cache[30] = _createElementVNode("div", { class: "col-md-7" }, [
                        _createElementVNode("h3", { class: "fs-4 text-white" }, " Elements Electriques ")
                      ], -1)),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success", { 'cursor-not-allowed': _ctx.isDisable }]),
                            type: "button",
                            disabled: _ctx.isDisable,
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addRowElement()))
                          }, _cache[29] || (_cache[29] = [
                            _createElementVNode("i", { class: "fa fa-plus-circle position-relative ms-5 fs-12" }, null, -1),
                            _createTextVNode(" Ajouter un élément ")
                          ]), 10, _hoisted_30),
                          _createVNode(_component_router_link, { to: "/liste-mouvements" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      (_ctx.showHeader)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, _cache[31] || (_cache[31] = [
                            _createElementVNode("div", { class: "col-md-3" }, [
                              _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                _createTextVNode(" Elements "),
                                _createElementVNode("span", { class: "text-danger" }, "*")
                              ])
                            ], -1),
                            _createElementVNode("div", { class: "col" }, [
                              _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                _createTextVNode(" Prix unitaire "),
                                _createElementVNode("span", { class: "text-danger" }, "*")
                              ])
                            ], -1),
                            _createElementVNode("div", { class: "col" }, [
                              _createElementVNode("label", { class: "d-block text-black fw-semibold mb-5" }, [
                                _createTextVNode(" Quantite"),
                                _createElementVNode("span", { class: "text-danger" }, "*")
                              ])
                            ], -1),
                            _createElementVNode("div", { class: "col-md-2" }, [
                              _createElementVNode("label", { class: "d-block text-black fw-semibold mb-5" }, [
                                _createTextVNode(" Montant "),
                                _createElementVNode("span", { class: "text-danger" }, "*")
                              ])
                            ], -1),
                            _createElementVNode("div", { class: "col-md-3" }, [
                              _createElementVNode("label", { class: "d-block text-black fw-semibold mb-5" }, [
                                _createTextVNode(" Groupe de Taxe "),
                                _createElementVNode("span", { class: "text-danger" }, "*")
                              ])
                            ], -1),
                            _createElementVNode("div", { class: "col" }, [
                              _createElementVNode("label", { class: "d-block text-black fw-semibold mb-5" }, [
                                _createTextVNode(" Actions "),
                                _createElementVNode("span", { class: "text-danger" }, "*")
                              ])
                            ], -1)
                          ])))
                        : _createCommentVNode("", true),
                      _cache[33] || (_cache[33] = _createElementVNode("hr", { class: "mt-0" }, null, -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enfants, (enfant, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "row",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createVNode(_component_Multiselect, {
                                options: _ctx.elementOptions,
                                searchable: true,
                                onSelect: ($event: any) => (_ctx.chargerCler(enfant.element, index)),
                                multiple: true,
                                modelValue: enfant.element,
                                "onUpdate:modelValue": ($event: any) => ((enfant.element) = $event),
                                placeholder: "Sélectionner l'élément"
                              }, null, 8, ["options", "onSelect", "modelValue", "onUpdate:modelValue"]),
                              (_ctx.valideteRowElement(enfant.element))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_34))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((enfant.prix) = $event),
                                type: "number",
                                class: "form-control shadow-none fs-md-15 text-black",
                                readonly: true,
                                placeholder: ""
                              }, null, 8, _hoisted_37), [
                                [_vModelText, enfant.prix]
                              ])
                            ]),
                            (_ctx.valideteRowElement(enfant.prix))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, " Le prix est obligatoire. "))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((enfant.quantite) = $event),
                                type: "number",
                                class: "form-control shadow-none fs-md-15 text-black",
                                placeholder: "saisir la quantité",
                                min: "0.1",
                                onKeydown: _cache[15] || (_cache[15] = (event) => ['e', 'E', '-'].includes(event.key) && event.preventDefault())
                              }, null, 40, _hoisted_41), [
                                [_vModelText, enfant.quantite]
                              ]),
                              (_ctx.valideteRowElement(enfant.quantite))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, " La quantité est obligatoire. "))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((enfant.montant) = $event),
                                type: "text",
                                class: "form-control shadow-none fs-md-15 text-black",
                                placeholder: "Saisir le montant"
                              }, null, 8, _hoisted_45), [
                                [_vModelText, enfant.montant]
                              ]),
                              (_ctx.valideteRowElement(enfant.montant))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, " Le montant est obligatoire. "))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                              _createVNode(_component_Multiselect, {
                                options: _ctx.groupeTaxeOption,
                                searchable: true,
                                multiple: true,
                                modelValue: enfant.groupeTaxe,
                                "onUpdate:modelValue": ($event: any) => ((enfant.groupeTaxe) = $event),
                                disabled: _ctx.estTPS == true,
                                placeholder: "Sélectionner un groupe"
                              }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "disabled"]),
                              (_ctx.valideteRowElement(enfant.groupeTaxe))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_49))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("button", {
                              class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                              type: "button",
                              onClick: ($event: any) => (_ctx.removeRowElement(index))
                            }, _cache[32] || (_cache[32] = [
                              _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1)
                            ]), 8, _hoisted_51)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _withDirectives(_createElementVNode("button", _hoisted_54, " Enregistrer ", 512), [
                    [_vShow, !_ctx.auclic]
                  ]),
                  _withDirectives(_createElementVNode("button", _hoisted_55, _cache[34] || (_cache[34] = [
                    _createElementVNode("span", {
                      class: "spinner-grow spinner-grow-sm",
                      role: "status",
                      "aria-hidden": "true"
                    }, null, -1),
                    _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                  ]), 512), [
                    [_vShow, _ctx.auclic]
                  ]),
                  _createVNode(_component_router_link, {
                    to: "/liste-contrats",
                    class: "btn btn-danger"
                  }, {
                    default: _withCtx(() => _cache[35] || (_cache[35] = [
                      _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                      _createElementVNode("span", { class: "position-relative" }, null, -1),
                      _createTextVNode("Annuler")
                    ])),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}